<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="581" scrollable>
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Sửa điểm
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text v-if="student.id">
        <v-form ref="form" class="py-4">
          <v-row>
            <v-col cols="6">
              <div class="text-caption my-0">Học sinh</div>
              <CardStudentName :isShowCode="false" :student="student" />
            </v-col>
            <v-col class="d-flex justify-space-between align-center" cols="6">
              <div>
                <div class="text-caption my-0">Ngày sinh</div>
                <span class="black--text">{{ student.dob | ddmmyyyy }}</span>
              </div>
              <div>
                <div class="text-caption my-0">Mã số</div>
                <span class="black--text">{{ student.code | getStudentCode }}</span>
              </div>
              <div>
                <div class="text-caption my-0">Lớp</div>
                <span class="black--text">{{ filterParam.class.title }}</span>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="filterParam.subject.markType === 'mark'">
            <v-col cols="3">
              <div>
                <p class="text-caption my-0">Điểm hiện tại</p>
                <span class="text-subtitle-2 font-weight-black">{{ mark.value }}</span>
              </div>
            </v-col>
            <v-col cols="3" class="d-flex justify-center align-start">
              <v-icon large>mdi-arrow-right</v-icon>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="markValue"
                outlined
                label="Điểm mới"
                dense
                type="number"
                :rules="[$rules.required, $rules.markInput]"
                class="required"
              />
            </v-col>
          </v-row>

          <!-- evaluate -->
          <v-row v-else>
            <v-col cols="3">
              <div>
                <p class="text-caption my-0">Điểm hiện tại</p>
                <span class="text-subtitle-2 font-weight-black">{{ mark.value | getEvaluate }}</span>
              </div>
            </v-col>
            <v-col cols="3" class="d-flex justify-center align-start">
              <v-icon large>mdi-arrow-right</v-icon>
            </v-col>
            <v-col cols="6">
              <v-select
                label="Đánh giá"
                :items="evaluateItems"
                v-model="markValue"
                outlined
                dense
                :rules="[$rules.required]"
                class="required"
                hide-details
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn class="ma-2" outlined color="error" @click="remove">Xóa điểm</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="ma-2" dark depressed color="#0D47A1" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import CardStudentName from '@/components/basic/card/CardStudentName'

export default {
  components: {
    CardStudentName
  },
  data() {
    return {
      dialog: false,
      markValue: null
    }
  },
  props: {
    state: Boolean,
    mark: Object,
    student: Object
  },
  computed: {
    ...mapState('ClassMarkInput', ['filterParam']),
    evaluateItems() {
      if (this.mark.value) return [{ text: 'Chưa Đạt', value: 0 }]
      return [{ text: 'Đạt', value: 1 }]
    }
  },
  methods: {
    ...mapActions('ClassMarkInput', ['updateMark', 'removeMark']),
    async save() {
      if (!this.$refs.form.validate()) return
      if (this.markValue == this.mark.value) return this.$alert.error('Điểm mới phải khác điểm hiện tại')
      try {
        this.$loading.active = true

        await this.updateMark({ id: this.mark.id, value: this.markValue })
        this.$alert.updateSuccess()
        this.$refs.form.reset()
        this.$emit('updatedMark')
      } catch (error) {
        this.$alert.updateError()
      } finally {
        this.$loading.active = false
      }

      this.dialog = false
    },
    async remove() {
      this.$dialog.confirm({
        title: 'Xóa đầu điểm',
        text: 'Bạn có chắc chắn muốn xóa điểm hiện tại của học sinh này? Thao tác này sẽ không thể hoàn tác.',
        okText: 'Có',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true

            await this.removeMark(this.mark.id)
            this.$alert.deleteSuccess('đầu điểm')
            this.$refs.form.reset()
            this.$emit('updatedMark')
          } catch (error) {
            this.$alert.updateError()
          } finally {
            this.$loading.active = false
          }

          this.dialog = false
        }
      })
    },
    cancel() {
      this.dialog = false
      this.$refs.form.reset()
    }
  },

  watch: {
    state() {
      this.dialog = true
    }
  }
}
</script>
